import { useFieldArray, useFormContext } from 'react-hook-form';

import type { AddIpRangeForm } from '../add-ip-range-form/add-ip-range-form';
import { DeleteConfirmationDialog } from '../delete-confirmation-dialog/delete-confirmation-dialog';

type Props = {
  index: number;
};

export const DeleteExclusionDialog = ({ index }: Props) => {
  const { control, resetField } = useFormContext<AddIpRangeForm>();

  const { remove } = useFieldArray({
    control,
    name: 'scanExclusions',
  });

  return (
    <DeleteConfirmationDialog
      variant="tertiary"
      actionOnClick={() => {
        remove(index);
        resetField('newExclusion', {
          defaultValue: { ipRange: '', ports: '' },
          keepDirty: false,
        });
      }}
    />
  );
};
